import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  Observable } from 'rxjs';
import { ApiResponse, ConversionResponse, PaginatedItem, ZipConversionResponse } from '../../../../../../../common/models/api-response';
import { BaseService } from '../../../../../../../shared/services/base.service';
import { Formats, IconPackDetail, PackDetail } from '../../../../../../contributor/components/profile/contributors/pack/models/pack';
import { IconPackCollection, Likes } from '../models/comment';
import { PackMetaData } from '../models/packMetaData';
import { commentVM } from '../models/commentVM';
import { reportVM } from '../models/reportVM';
import { CreateComment } from '../models/createComment';
import { DetailCommemnt } from '../models/detailComment';
import { likeVM } from '../models/likeVM';
import { PackDetailMetaData } from '../models/packDetailMetaData';
import { ImageFormat } from '../models/image-format';
import { Follow } from '../../../contributors/models/follow';
import { FollowMetaData } from '../../../contributors/models/followMetaData';
import { IconPackVM } from '../models/iconPackVM';
import { LisenceEnum } from '../../../../../../../shared/models/license';
import { ContributorsReportCollection } from '../models/ContributorsReportCollection';



@Injectable({
  providedIn: 'root'
})
export class IconGalleryService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }
  canUserCopyPremiumIcon(fc: IconPackDetail){
    var route=`${this.baseUrl}/can-user-copy-premium-icon`;
    return this.http.post<boolean>(route,fc);
  }
getImageBlob(url: string) {
  return this.http.get(url, { responseType: 'blob' });
}
  downloadIcon(fc:IconPackDetail,format:string,size:number,isUserLogin:boolean){
    const path = isUserLogin ? (fc.lisenceName ===LisenceEnum.Premium.toString() ? 'download/premium-icon/authenticated' : 'download/free-icon/authenticated') : 'download';
    var route=`${this.baseUrl}/${path}?format=${format}&size=${size}`;
    return this.http.post<ConversionResponse>(route, fc);
  }


   downloadPackZip(iconPackId:string,iconPackDetailID:string,lisenceId:number,isUserLogin:boolean,formats:string[],sizesByFormat:number[]) {
    
    const path =isUserLogin ? (lisenceId===1 ? 'downloadZipPack/premium/authenticated' : 'downloadZipPack/free/authenticated') : 'downloadZip';
    var route=`${this.baseUrl}/${path}`;
    const body = {
      iconPackId,
      iconPackDetailID,
      formats,
      sizesByFormat,
    };
    return this.http.post<ZipConversionResponse>(route, body);
  }
  getdownloadMetaData(iconPackId:string,iconPackDetailId:string,lisenceId:number,isUserLogin:boolean,formats:string[],sizesByFormat:number[]) {
    const path =isUserLogin ? (lisenceId===1 ? 'getdownloadMetaData/premium/authenticated' : 'getdownloadMetaData/free/authenticated') : 'getdownloadMetaData';
    var route=`${this.baseUrl}/${path}`;
      const body = {
      iconPackId,
      iconPackDetailId,
      formats,
      sizesByFormat,
    };
     return this.http.post(route, body, { responseType: 'blob' });
  }
  createcomment(fc:CreateComment) {

    const route = `${this.baseUrl}/createpackcomment`;
    return this.http.post<ApiResponse<IconPackCollection>>(route,fc);
  }
  createDetailcomment(fc:DetailCommemnt) {
        const route = `${this.baseUrl}/createpackdetcomment`;
        return this.http.post<ApiResponse<IconPackCollection>>(route,fc);
}
  createPacklike(iconPackId: string) {

    const route = `${this.baseUrl}/createPackLike?iconPackId=${iconPackId}`;
    return this.http.post<IconPackCollection>(route,'');
  }
  createFollow(userId:string |undefined) {
    const route = `${this.baseUrl}/createFollow?UserId=${userId}`;
    return this.http.post<Follow>(route,'');
  }
  createPackView(iconPackId: string,iconPackDetailId:string) {

    const route = `${this.baseUrl}/createPackView?iconPackId=${iconPackId}&iconPackDetailId=${iconPackDetailId}`;
    return this.http.post<IconPackCollection>(route,'');
  }
  createPackDetaillike(iconPackId: string, iconPackDetailId: string) {

    const route = `${this.baseUrl}/createPackDetaillike?iconPackId=${iconPackId}&iconPackDetailId=${iconPackDetailId}`;
    return this.http.post<IconPackCollection>(route,'');
  }
  createpackreport(iconPackId: string,reportID:number,description:string) {
    const route = `${this.baseUrl}/PackReport?iconPackId=${iconPackId}&reportID=${reportID}&description=${description}`;
    return this.http.post<IconPackCollection>(route,'');
  }


  createpackdetailreport(iconPackId: string, iconPackDetailId: string,reportID:number,description:string) {

    const route = `${this.baseUrl}/PackDetailReport?iconPackId=${iconPackId}&iconPackDetailId=${iconPackDetailId}&reportID=${reportID}&description=${description}`;
    return this.http.post<IconPackCollection>(route,'');
  }
 createContributorReport(contributorId: string,reportID:number,description:string) {
    const route = `${this.baseUrl}/ContributorsReport?contributorId=${contributorId}&reportID=${reportID}&description=${description}`;
    return this.http.post<ContributorsReportCollection>(route,'');
  }
  getIconPackMetaData(iconPackId: string,isUserLogin:boolean) {
    const path = isUserLogin ? 'getPackMetadata/authenticated' : 'getPackMetadata';
    const route = `${this.baseUrl}/${path}?iconPackId=${iconPackId}`;
    return this.http.get<PackMetaData>(route);
  }

   getFormats(iconPackDetailId: string,categoryName:string) {
    const path = 'getIconFormats';
    const route = `${this.baseUrl}/${path}?iconPackDetailId=${iconPackDetailId}&categoryName=${categoryName}`;
    return this.http.get<Formats[]>(route);
  }
   getIconPackZip(iconPackId: string) {
    const path =  'pack/zip';
    const route = `${this.baseUrl}/${path}?iconPackId=${iconPackId}`;
    return this.http.get<IconPackVM>(route);
  }
   getFollowMetaData(isUserLogin:boolean,isContributorUserId:string|undefined) {
    const path = isUserLogin ? 'getFollowMetadata/authenticated' : 'getFollowMetadata';
    const route = `${this.baseUrl}/${path}?isContributorUserId=${isContributorUserId}`;
    return this.http.get<FollowMetaData>(route);
  }
  getIconPackDetailMetaData(iconPackId: string, iconPackDetailId: string,isUserLogin:boolean) {
    const path = isUserLogin ? 'getPackDetailMetadata/authenticated' : 'getPackDetailMetadata';
    const route = `${this.baseUrl}/${path}?iconPackId=${iconPackId}&iconPackDetailId=${iconPackDetailId}`;
    return this.http.get<PackDetailMetaData>(route);
  }
  getPackcomment(iconPackId: string) {

    const route = `${this.baseUrl}/getPackComments?iconPackId=${iconPackId}`;
    return this.http.get<commentVM>(route);
  }

  getPackDetailcomment(iconPackId: string, iconPackDetailId: string) {

    const route = `${this.baseUrl}/getPackDetailComments?iconPackId=${iconPackId}&iconPackDetailId=${iconPackDetailId}`;
    return this.http.get<commentVM>(route);
  }
  downloadIconOnBrowser(url: string,filename:string,format:string,size:number) {
    
    filename = filename.split('.')[0];
    if (!url) {
      return;
    }
    this.downloadFile(url).subscribe((blob: Blob) => {
      const a = document.createElement('a');
      const fileURL = URL.createObjectURL(blob);
      a.href = fileURL;
      var downloadedFileName = this.getCleanedFilename(filename,format,size);
      a.download = downloadedFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

  getCleanedFilename(filename: string,format:string,size:number): string {
    let cleanedString = filename.replace(/\.[^/.]+$/, '');
    cleanedString = cleanedString.replace(/[^a-zA-Z\s]/g, '');
    if(format.toLowerCase() === ImageFormat.Gif.toString().toLowerCase()
      || format.toLowerCase() === ImageFormat.Png.toString().toLowerCase()
      || format.toLowerCase() === ImageFormat.Json.toString().toLowerCase()
      ){
        filename = filename + '-'+size+'px';
      }
      const ext =
      format === 'wmp4' ? 'mp4' :
      format === 'wpng' ? 'png' :
      format === 'delottie' ? 'json' :
      format;
    return `${filename}.${ext}`;
  }

  triggerDownload(prefix:string,url: string, format: string) {

    const link = document.createElement('a');
    link.href = url;

    const fileName = `${prefix}_${Date.now()}.${format.toLowerCase()}`;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadBase64(prefix: string, base64: string, format: string) {
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;
    const mimeTypes: { [key: string]: string } = {
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      svg: 'image/svg+xml',
      webp: 'image/webp',
      json: 'application/json',
      zip: 'application/zip',
    };
    const mimeType = mimeTypes[format.toLowerCase()] || 'application/octet-stream';
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const fileName = `${prefix}.${format.toLowerCase()}`;
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

}
